import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TenantLocationsService {
  getTenantLocations() {
    return ApiService.get(`${Config.api.document.url}api/v1/tenant-locations`).then((response) => {
      return response.data;
    });
  }

  addTenantLocation(locationData) {
    return ApiService.post(`${Config.api.document.url}api/v1/tenant-locations`, locationData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  editTenantLocation(locationId, updatedData) {
    return ApiService.put(`${Config.api.document.url}api/v1/tenant-locations/${locationId}`, updatedData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  deleteTenantLocation(locationId) {
    return ApiService.delete(`${Config.api.document.url}api/v1/tenant-locations/${locationId}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }
}

export const tenantLocationsService = new TenantLocationsService();
